import React, { useState, useEffect } from 'react';
import { Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

const baseUrl = 'https://cxd.bibi.com:3636';
const orange = '#FE5D00';

function getFileType(path) {
  const ext = path?.split('.').pop()?.toLowerCase();
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext))
    return 'image';
  if (['mp4', 'mov', 'avi', 'wmv', 'mkv'].includes(ext)) return 'video';
  if (ext === 'pdf') return 'pdf';
  return 'other';
}

export function GalleryModal({ open, onClose, files = [], initialIndex = 0 }) {
  const [index, setIndex] = useState(initialIndex);

  useEffect(() => {
    if (open) setIndex(initialIndex);
  }, [open, initialIndex]);

  if (!open) return null;
  const caminho = files[index];
  const type = getFileType(caminho);

  function handlePrev() {
    setIndex((prev) => (prev === 0 ? files.length - 1 : prev - 1));
  }
  function handleNext() {
    setIndex((prev) => (prev === files.length - 1 ? 0 : prev + 1));
  }

  return (
    <Box
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.93)',
        backdropFilter: 'blur(8px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconButton
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 32,
          right: 32,
          color: orange,
          zIndex: 10000,
        }}
        aria-label="Fechar"
      >
        <CloseIcon style={{ fontSize: 40 }} />
      </IconButton>
      <IconButton
        onClick={handlePrev}
        style={{ position: 'absolute', left: 32, color: orange, zIndex: 10000 }}
        aria-label="Anterior"
      >
        <ArrowBackIosIcon style={{ fontSize: 40 }} />
      </IconButton>
      <IconButton
        onClick={handleNext}
        style={{
          position: 'absolute',
          right: 32,
          color: orange,
          zIndex: 10000,
        }}
        aria-label="Próximo"
      >
        <ArrowForwardIosIcon style={{ fontSize: 40 }} />
      </IconButton>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '80vw',
          height: '80vh',
          maxWidth: 800,
          maxHeight: 600,
          background: 'rgba(0,0,0,0.0)',
          borderRadius: 16,
        }}
      >
        {type === 'image' && (
          <img
            src={baseUrl + caminho}
            alt="preview"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              borderRadius: 12,
              boxShadow: '0 2px 16px rgba(0,0,0,0.3)',
            }}
          />
        )}
        {type === 'pdf' && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={() => window.open(baseUrl + caminho, '_blank')}
              style={{ color: orange, marginBottom: 16 }}
              aria-label="Abrir PDF"
            >
              <PictureAsPdfIcon style={{ fontSize: 80 }} />
            </IconButton>
            <span style={{ color: '#fff', fontSize: 18 }}>PDF</span>
          </Box>
        )}
        {type === 'video' && (
          <video
            src={baseUrl + caminho}
            controls
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              borderRadius: 12,
              background: '#000',
            }}
          >
            Seu navegador não suporta vídeo.
          </video>
        )}
        {type === 'other' && (
          <Box style={{ color: '#fff', fontSize: 18 }}>
            Arquivo não suportado
          </Box>
        )}
      </Box>
    </Box>
  );
}
